import DataSet from '@antv/data-set';
import { groupBy } from 'lodash'
import { toHash } from '@/utils/common'
function GetNumberOfDays(sDate: any, eDate: any) {//获得天数
  var sArr = sDate.split('-');
  var eArr = eDate.split('-');
  var sRDate: any = new Date(sArr[0], sArr[1], sArr[2]);
  var eRDate: any = new Date(eArr[0], eArr[1], eArr[2]);
  var day = (eRDate - sRDate) / (24 * 60 * 60 * 1000); // 天数
  return day
};
export function getColumnData(dataObj) {
  const { data, indexes, dimensions } = dataObj
  const types = indexes.map((item) => {
    return item.name
  })
  const ds = new DataSet();
  const dv = ds
    .createView()
    .source(data)
    .transform({
      type: 'rename',
      map: toHash([...indexes, ...dimensions], 'id', 'name')
    })
    .transform({
      type: 'fold',
      fields: types, // 展开字段集
      key: 'type', // key字段
      value: 'value', // value字段
    });
  return dv.rows
}
export function getBarData(dataObj) {
  const { data, indexes, dimensions } = dataObj
  const types = indexes.map((item) => {
    return item.id
  })
  const dimensionzIds = dimensions.map((item) => {
    return item.id
  })
  const ds = new DataSet();
  const dv = ds
    .createView()
    .source(data)
    .transform({
      type: 'map',
      callback(row) {
        row.x = dimensionzIds.map((item) => {
          return row[item]
        }).join('-')
        return row;
      },
    })
    .transform({
      type: 'fold',
      fields: types, // 展开字段集
      key: 'type', // key字段
      value: 'value', // value字段
    });
  return dv.rows
}
export function getPieData(dataObj) {
  const { data, indexes, dimensions } = dataObj
  const ds = new DataSet()
  const dv = ds.createView().source(data)
  if (dimensions.length === 0) {
    const types = indexes.map((item) => {
      return item.id
    })
    dv.transform({
      type: 'fold',
      fields: types, // 展开字段集
      key: 'type', // key字段
      value: 'value', // value字段
    }).transform({
      type: 'map',
      callback(row) {
        let index = indexes.find((item) => item.id === row.type)
        row.type = index.name
        row.a = 1
        console.log(row)
        return row;
      },
    })
  } else {
    dv.transform({
      type: 'rename',
      map: {
        [dimensions[0].id]: 'type',
        [indexes[0].id]: 'value',
      }
    }).transform({
      type: 'map',
      callback(row) {
        row.const = 'const'
        return row;
      },
    })
  }
  dv.transform({
    type: 'percent',
    field: 'value',
    dimension: 'type',
    as: 'percent',
  })
  return dv.rows
}
export function getFunnelData(dataObj) {
  const { data, indexes, dimensions } = dataObj
  const ds = new DataSet()
  const dv = ds.createView().source(data)
  if (dimensions.length === 0) {
    const types = indexes.map((item) => {
      return item.id
    })
    dv.transform({
      type: 'fold',
      fields: types, // 展开字段集
      key: 'type', // key字段
      value: 'value', // value字段
    }).transform({
      type: 'map',
      callback(row) {
        let index = indexes.find((item) => item.id === row.type)
        row.type = index.name
        return row;
      },
    })
  } else {
    dv.transform({
      type: 'rename',
      map: {
        [dimensions[0].id]: 'type',
        [indexes[0].id]: 'value',
      }
    })
  }
  return dv.rows
}
function sunburstFn(dataObj) {
  const { data = [], indexes, dimensions = [] } = dataObj
  const dimensionIds = dimensions.map((item) => {
    return item.id
  })
  let obj: any = {}
  let list: any = []
  const indexId = indexes[0].id
  data.forEach((item) => {
    let key = ''
    dimensionIds.forEach((dimensionId, index) => {
      let name = item[dimensionId]
      if (index === 0) {
        key += name;
        if (!obj[key]) {
          let sunItem = { name, children: [] }
          obj[key] = sunItem
          list.push(sunItem)
        }
      } else if (index === (dimensionIds.length - 1)) {
        let children = obj[key].children
        key += '/' + name
        if (!obj[key]) {
          let sunItem = { name, children: [] }
          children.push(sunItem)
          obj[key] = sunItem
        }
      } else {
        let children = obj[key].children
        key += '/' + name;
        if (!obj[key]) {
          let sunItem = { name, children: [] }
          obj[key] = sunItem
          children.push(sunItem)
        }
      }
    })
    let value = item[indexId]
    obj[key].value = value
  })
  return list
} function getSunburstData(dataObj) {
  const { data = [], indexes, dimensions = [] } = dataObj
  const sunburstData = sunburstFn(dataObj)
  const ds = new DataSet()
  const dv = ds.createView().source({ name: 'root', children: sunburstData }, {
    type: 'hierarchy',
  })
  dv.transform({
    type: 'hierarchy.partition',
    field: 'value',
    size: [1, 1], // width, height
    round: false,
    // ratio: 1.618033988749895, // golden ratio
    padding: 0, // 各种 padding 配置
    as: ['x', 'y'], // 矩形的顶点集
    // x: [ x0, x1, x2, x3 ], y: [ y0, y1, y2, y3 ]
  });
  return dv
}
export const getData = (data) => {
  const source: any = [];
  const nodes = getSunburstData(data).getAllNodes();
  nodes.map((node) => {
    if (node.depth === 0) {
      // 父节点不展示
      return null;
    }
    const obj: any = {};
    obj.name = node.data.name;
    obj.value = node.value;
    obj.x = node.x;
    obj.id = Math.random()
    obj.depth = node.depth
    obj.y = node.y;
    source.push(obj);
    return node;
  });
  const ds = new DataSet()
  const dv = ds.createView().source(source)
    .transform({
      type: 'percent',
      dimension: 'id',
      field: 'value',
      groupBy: ['depth'],
      as: 'percent'
    })
  return dv.rows
}
export const getMap = (mapData, data) => {
  const ds = new DataSet();
  const chinaMap = ds.createView('back')
    .source(mapData, {
      type: 'GeoJSON'
    });
  const userDv = ds.createView()
    .source(data.data)
    .transform({
      geoDataView: chinaMap,
      field: data.dimensions[0].id,
      type: 'geo.region',
      as: ['longitude', 'latitude']
    })
  return { rows: chinaMap.rows, rowsItem: userDv.rows }
}

export const ganttDv = (dataAll) => {
  const { data = [], indexes = [], dimensions = [] } = dataAll;
  console.log(data)
  const ds = new DataSet();
  const dv = ds.createView().source(data);
  dv.transform({
    type: 'map',
    callback(row) {
      row.type = String(row[dimensions[0].id])
      row[`value`] = [row[dimensions[dimensions.length - 2].id].trim(), row[dimensions[dimensions.length - 1].id].trim()]; // 为每条记录新添加一个 z 字段
      var sDate = row[dimensions[dimensions.length - 2].id];
      var eDate = row[dimensions[dimensions.length - 1].id]
      row.day = GetNumberOfDays(sDate, eDate)
      if (dimensions.length === 3) {
        row.val = row[dimensions[0].id];
      } else {
        row.val = row[dimensions[1].id] || row[dimensions[0].id];
        if (dimensions[1].id === dimensions[dimensions.length - 2].id || dimensions[1].id === dimensions[dimensions.length - 1].id) {
          row.val = 'val'
        }

      }
      return row;
    },
  });
  return dv.rows.filter((item) => {
    if (item.value[0] && item.value[1] && item.type !== 'undefined') {
      return item
    }
  })
}
